import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe, Location } from '@angular/common';
import { Router } from '@angular/router';
import moment from 'moment';
import { Moment } from 'moment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EthicStandardsAndCorporateCultureService } from './ethic-standards-and-corporate-culture.service';
import { CustomPdfViewerComponent } from '../shared/custom-pdf-viewer.component';

@Component({
  selector: 'ad-ethic-standards-and-corporate-culture',
  imports: [AsyncPipe, CustomPdfViewerComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="card border-0 bg-transparent d-flex flex-column" style="height: 88vh;">
      <div class="card-header">
        <h5 class="card-title mb-1">Ethic Standards &amp; Corporate Culture</h5>
        <p class="card-text text-muted">
          Please read the ethic standards &amp; corporate culture manual and acknowledge by clicking the button at the
          end of the page.
        </p>
      </div>
      <div class="card-body p-0">
        <ad-custom-pdf-viewer
          fileName="EthicStandardsCorporateCulture.2026.1.pdf"
          (endOfDocumentReached)="isAtEndOfDocument = true"
        />
      </div>
      <div class="card-footer flex-shrink-0">
        <div class="btn-group">
          @if (alreadyAcked$ | async) {
            <button class="btn btn-primary" disabled>YOUR ALREADY ACKNOWLEDGED READING THIS DOCUMENT</button>
          } @else {
            <button class="btn btn-primary" [disabled]="!isAtEndOfDocument" (click)="acknowledge()">
              ACKNOWLEDGE AND AGREE
            </button>
          }
          <button class="btn btn-secondary" (click)="location.back()">BACK</button>
        </div>
      </div>
    </div>
  `
})
export class EthicStandardsAndCorporateCultureComponent implements OnInit {
  public isAtEndOfDocument = false;
  public alreadyAcked$!: Observable<boolean | null>;

  private start!: Moment;

  constructor(
    private router: Router,
    private ethicStandardsAndCorporateCultureService: EthicStandardsAndCorporateCultureService,
    protected location: Location
  ) {}

  ngOnInit(): void {
    this.start = moment();
    this.alreadyAcked$ = this.ethicStandardsAndCorporateCultureService
      .getMine$()
      .pipe(map((item) => item && item.acknowledged));
  }

  public acknowledge(): void {
    this.ethicStandardsAndCorporateCultureService
      .acknowledge$(moment.duration(moment().diff(this.start)).asMilliseconds())
      .subscribe(() => this.router.navigate(['/']));
  }
}
